(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/components/loader.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/components/loader.js');
"use strict";


const {
  useEffect
} = React;
const Loader = () => {
  useEffect(() => {
    svs.components.loader.show();
    return () => svs.components.loader.hide();
  }, []);
  return null;
};
setGlobal('svs.ticketsOrderHome.components.Loader', Loader);

 })(window);